import React from 'react';
import type { MaterialFieldSpec } from '../lib/masterMaterialFields';
import HelpHint from './HelpHint';

interface Props {
  /** Translator (tenant `useLocale().t`; admin Spanish-fallback resolver). */
  t: (key: string) => string;
  /** The section's currently-visible fields — each row is label + help. */
  fields: readonly MaterialFieldSpec[];
  className?: string;
}

/**
 * The "?" of a form section header (catalog forms, tenant + platform-admin):
 * a `HelpHint` listing each visible field with a one-line plain-language
 * explanation (from the field-spec `helpKey`). i18n via the `t` prop so it
 * carries no app coupling.
 */
export default function SectionHelp({ t, fields, className = '' }: Props) {
  if (fields.length === 0) return null;
  return (
    <HelpHint label={t('catalog.helpAria')} className={className}>
      <ul className="space-y-2.5">
        {fields.map((f) => (
          <li key={f.key} className="text-xs leading-snug">
            <span className="font-bold text-slate-600 dark:text-slate-200">{t(f.labelKey)}</span>
            <span className="block text-slate-500 dark:text-slate-400 mt-0.5">{t(f.helpKey)}</span>
          </li>
        ))}
      </ul>
    </HelpHint>
  );
}
